import Select, { MultiValue } from "react-select";
import { FieldError } from "react-hook-form";

type OptionType = {
  value: string;
  label: string;
  name?: string;
};

type Props = {
  name: string;
  label?: string;
  options: OptionType[];
  value?: OptionType[] | undefined;
  onChange: (selected: OptionType[]) => void;
  error?: FieldError;
  className?: string;
  labelClass?: string;
  disabled?: boolean;
  selectClassName?: string;
  placeholder?: string;
};

export default function MultiSelectInputNew({
  name,
  label,
  options,
  value,
  onChange,
  error,
  labelClass = "",
  className = "",
  selectClassName,
  placeholder,
  disabled = false,
}: Props) {
  return (
    <div className={`space-y-1 ${className}`}>
      {label && (
        <label
          htmlFor={name}
          className={`text-[#1E293B] text-sm ${labelClass} whitespace-nowrap w-[40%]`}
        >
          {label}
        </label>
      )}
      <Select
        className="w-full text-sm"
        inputId={name}
        isMulti
        options={options}
        value={value}
        isDisabled={disabled}
        placeholder={placeholder}
        onChange={(newValue: MultiValue<OptionType>) => onChange([...newValue])}
        styles={{
          control: (base: any, state: any) => ({
            ...base,
            borderRadius: "10px",
            borderColor: error ? "#f87171" : "#e5e7eb",
            boxShadow: "none",
            fontSize: "0.875rem",
            maxHeight: "160px",
            overflow: "auto",
            backgroundColor: disabled ? "#f9fafb" : "white",
            cursor: disabled ? "not-allowed" : "pointer",
            paddingLeft: "14px",
            paddingRight: "4px",
          }),
          multiValue: (base: any) => ({
            ...base,
            backgroundColor: "#f3f4f6",
            borderRadius: "9999px",
            border: "0.5px",
            borderColor: "#e8e8e8",
            paddingLeft: "4px",
            paddingRight: "4px",
          }),
          placeholder: (base: any) => ({
            ...base,
            color: "#9ca3af",
          }),
          dropdownIndicator: (base: any) => ({
            ...base,
            color: "#9ca3af",
            paddingRight: "0.5rem",
            fontSize: "14px",
            maxHeight: "160px",
            overflowY: "auto",
          }),
        }}
      />

      {error && <p className="text-xs text-red-500">{error.message}</p>}
    </div>
  );
}
